export enum VotingPolicyModalStep {
  PoliciesIntroductionOne = 1,
  PoliciesIntroductionTwo = 2,
  PoliciesIntroductionThree = 3,
  PickAPolicy = 4,
  ConfirmedPolicy = 5,
}
